import { NavListItem, NavListSectionHeader } from "#root/components/nav-list";
import { Fragment, type ReactNode } from "react";
import { MdSearch } from "react-icons/md";
import { NavLink, useParams } from "react-router-dom";
import Layout from "../layout";

export default function (props: Parameters<typeof Layout>["0"]): ReactNode {
  const { providerCode } = useParams();

  return (
    <Layout
      {...props}
      syndicatedContentElements={
        providerCode ? (
          <Fragment>
            <NavListSectionHeader>Provider Code: {providerCode}</NavListSectionHeader>
            <NavLink end to={`/account/syndicatedContent/${providerCode}/`}>
              <NavListItem icon={MdSearch}>View Articles</NavListItem>
            </NavLink>
          </Fragment>
        ) : undefined
      }
    />
  );
}
